import React from "react";

export default function ViewImagePopup({ image, onClose, title = 'View Profile Picture' }) {
    return (
      <div
        style={{
          position: 'fixed',
          inset: 0,
          backgroundColor: 'rgba(0,0,0,0.6)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 10000,
        }}
      >
        <div
          style={{
            backgroundColor: '#fff',
            borderRadius: 10,
            width: '80%',
            maxWidth: 600,
            height: '80vh',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <div
            style={{
              position: 'sticky',
              top: 0,
              backgroundColor: '#fff',
              zIndex: 10,
              padding: '15px 20px',
              borderBottom: '1px solid #ddd',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <h5 style={{ margin: 0 }}>{title}</h5>
            <button
              onClick={onClose}
              style={{
                background: 'transparent',
                border: 'none',
                fontSize: 24,
                cursor: 'pointer',
                lineHeight: 1,
              }}
            >
              ✕
            </button>
          </div>

          {/* Image Content */}
          <div style={{ flex: 1, overflowY: 'auto', padding: 20 }}>
            {image ? (
              <img
                src={image}
                alt="Popup"
                style={{
                  width: '100%',
                  maxHeight: '100%',
                  objectFit: 'contain',
                }}
              />
            ) : (
              <p>No image to display.</p>
            )}
          </div>
        </div>
      </div>
    );
}
